import { RegisterPayload } from './types'
import client from '../../client'

export const register = (data: RegisterPayload) =>
  client.post<RegisterPayload>('v1/user/create/', data)
